import {
  MEMBERSHIPS_LIST,
  MEMBERSHIPS_ADD,
  MEMBERSHIPS_DELETE,
  MEMBERSHIPS_UPDATE,
  LOADING,
  NOT_FOUND,
} from "./type";
import { APIURL } from "./config";
import { toast } from "react-toastify";
import axios from "axios";

export const Memberships = () => async (dispatch) => {
  dispatch({
    type: LOADING,
    payload: "",
  });
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(`${APIURL}/api/v1/membership`, config);
    dispatch({
      type: MEMBERSHIPS_LIST,
      payload: res?.data,
    });
    if (res?.data?.data?.membership?.length === 0) {
      dispatch({
        type: NOT_FOUND,
        payload: "",
      });
    }
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const addMemberships = (val) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  var body = JSON.stringify({
    name: val.name,
    additionalDrivers: val.additionalDrivers,
    order_Counts: val.order_Counts,
    price: val.price,
    description: val.description,
    vehicleLimit: val.vehicleLimit,
    car: val.car,
    carPrice: val.carPrice,
    vehiclePrice: val.vehiclePrice,
    additionalDriversPrice: val.additionalDriversPrice,
    image: val.image == "undefined" ? "" : val.image,
    service_id: val.service_id,
    motorcyclePrice: val.motorcyclePrice,
    motorcycleAtvPrice: val.motorcycleAtvPrice,
    bicyclePrice: val.bicyclePrice,
    priceMonthly: val.priceMonthly,
    priceDaily: val.priceDaily,
    price1to7Days: val.price1to7Days,
    price7to30Days: val.price7to30Days,
    waitingPeriod: val.waitingPeriod,
    firstTimeDiscount: val.firstTimeDiscount,
    golfCartPrice: val.golfCartPrice
  });

  try {
    const res = await axios.post(`${APIURL}/api/v1/membership`, body, config);
    dispatch({ type: MEMBERSHIPS_ADD, payload: res.data });

    toast.success("Membership Created Successfully!");
    setTimeout(() => {
      return (window.location.href = "/manage-membership");
    }, 1000);
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};
export const upadteMemberships = (val, id, callBack) => async (dispatch) => {
  dispatch({
    type: LOADING,
  });
  const service_id = val?.service_id?.filter(function (el) {
    return el !== "";
  });
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  var body = JSON.stringify({
    name: val.name,
    additionalDrivers: val.additionalDrivers,
    order_Counts: val.order_Counts,
    vehicleLimit: val.vehicleLimit,
    additionalDriversPrice: val.additionalDriversPrice,
    price: val.price,
    car: val.car,
    carPrice: val.carPrice,
    image: val.image == "undefined" ? "" : val.image,
    description: val.description,
    vehiclePrice: val.vehiclePrice,
    service_id: val.service_id,
    motorcyclePrice: val.motorcyclePrice,
    motorcycleAtvPrice: val.motorcycleAtvPrice,
    bicyclePrice: val.bicyclePrice,
    status: val?.status,
    priceMonthly: val.priceMonthly,
    priceDaily: val.priceDaily,
    price1to7Days: val.price1to7Days,
    price7to30Days: val.price7to30Days,
    waitingPeriod: val.waitingPeriod,
    firstTimeDiscount: val.firstTimeDiscount,
    golfCartPrice: val.golfCartPrice
  });

  try {
    const res = await axios.patch(
      `${APIURL}/api/v1/membership/${id}`,
      body,
      config
    );
    dispatch({ type: MEMBERSHIPS_UPDATE, payload: res.data });
    // console.log(res, "resres");
    toast.success("Membership Updated Successfully!");
    callBack("success");
    setTimeout(() => {
      return (window.location.href = "/manage-membership");
    }, 1000);
  } catch (error) {
    callBack("error235345");
    // toast.error(error?.response?.data?.message);
  }
};

export const membershipDelete = (id) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    if (window.confirm("Do you want to delete membership?")) {
      const res = await axios.delete(
        `${APIURL}/api/v1/membership/${id}`,
        config
      );
      toast.success("Membership Deleted Successfully!");
      dispatch({
        type: MEMBERSHIPS_DELETE,
        payload: res?.data,
      });
    }
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};
